import { select } from "redux-saga/effects";
import { toast } from "react-toastify";
import * as errorTranslations from "src/settings/translation/locales/errors";

export function* toastError(id, autoClose = false) {
  const lang = yield select((state) => state.common.lang);
  const result = errorTranslations[lang][id];
  toast.error(result, { autoClose });
}

export function* toastSuccess(id, autoClose = false) {
  const lang = yield select((state) => state.common.lang);
  const result = errorTranslations[lang][id];
  toast.success(result, { autoClose });
}
